import React, { useEffect, useState } from "react";
import { ConfirmationBlockOcupacao } from "./Ocupacao";
import { ConfirmationBlockComponenteCurricular } from "./ComponenteCurricular";
import { AccountApi } from "../../../api/account/account.api";
import Cookies from "js-cookie";
import { ConfirmationBlockEtapa } from "./Etapa";
import { ConfirmationBlockTerritorio } from "./Territorio";
import { ConfirmationBlockRaca } from "./Raca";

const COOKIES_NAME = {
  CLOSE: "ane-confirmation-block_close",
  OCUPACAO: "ane-confirmation-block_6d19a3d628",
  COMPONENTE: "ane-confirmation-block_96e0eb2d4a",
  ETAPA: "ane-confirmation-block_yhbh327kfyj",
  TERRITORIO: "ane-confirmation-block_4ab5f7bf59",
  RACA: "ane-confirmation-block_c2855801ba",
  REMATRICULA: "ane-confirmation-block_bfef93f29c",
};

export const ConfirmationBlock = () => {
  const [user, setUser] = useState(null);
  const [showAlert, setShowAlert] = useState(false);

  const fetchUser = async (accessToken) => {
    try {
      const data = await AccountApi.getUser(accessToken);

      setUser(data);
    } catch (_) {
      setUser(null);
    }
  };

  const handleNextBlock = async (accessToken) => {
    const data = await AccountApi.getUser(accessToken);

    setUser(data);

    if (
      data &&
      data.ocupacao &&
      (data.ocupacao === "OUTRA" ||
        (data.disciplinas &&
          data.disciplinas.length > 0 &&
          data.etapas &&
          data.etapas.length > 0)) &&
      data.enderecos &&
      data.enderecos.length > 0 &&
      data.enderecos[0].estado &&
      data.enderecos[0].cidade
    ) {
      setShowAlert(true);
    }
  };

  useEffect(() => {
    const accessToken = Cookies.get("Bearer");

    if (accessToken) fetchUser(accessToken);
  }, []);

  if (!user) return null;

  const { ocupacao, etapas, disciplinas, raca, enderecos } = user;
  const dtUltimaModificacao = new Date(user.dtUltimaModificacao);

  const lastYear = new Date();
  lastYear.setMonth(lastYear.getMonth() - 12);

  if (Cookies.get(COOKIES_NAME.CLOSE)) return null;

  if (
    (!ocupacao || (ocupacao && dtUltimaModificacao < lastYear)) &&
    !Cookies.get(COOKIES_NAME.OCUPACAO)
  )
    return (
      <ConfirmationBlockOcupacao user={user} fetchUser={handleNextBlock} />
    );

  if (
    ocupacao !== "OUTRA" &&
    (!disciplinas ||
      disciplinas.length === 0 ||
      (disciplinas &&
        disciplinas.length > 0 &&
        (dtUltimaModificacao < lastYear ||
          Cookies.get(COOKIES_NAME.REMATRICULA)))) &&
    !Cookies.get(COOKIES_NAME.COMPONENTE)
  )
    return (
      <ConfirmationBlockComponenteCurricular
        user={user}
        fetchUser={handleNextBlock}
      />
    );

  if (
    ocupacao !== "OUTRA" &&
    (!etapas ||
      etapas.length === 0 ||
      (etapas &&
        etapas.length > 0 &&
        (dtUltimaModificacao < lastYear ||
          Cookies.get(COOKIES_NAME.REMATRICULA)))) &&
    !Cookies.get(COOKIES_NAME.ETAPA)
  )
    return <ConfirmationBlockEtapa user={user} fetchUser={handleNextBlock} />;

  if (
    (!enderecos ||
      enderecos.length === 0 ||
      (enderecos.length > 0 &&
        (!enderecos[0].estado || !enderecos[0].cidade)) ||
      (enderecos &&
        enderecos.length > 0 &&
        enderecos[0].estado &&
        enderecos[0].cidade &&
        (dtUltimaModificacao < lastYear ||
          Cookies.get(COOKIES_NAME.REMATRICULA)))) &&
    !Cookies.get(COOKIES_NAME.TERRITORIO)
  )
    return (
      <ConfirmationBlockTerritorio user={user} fetchUser={handleNextBlock} />
    );

  if (
    (!raca ||
      (raca &&
        (dtUltimaModificacao < lastYear ||
          Cookies.get(COOKIES_NAME.REMATRICULA)))) &&
    !Cookies.get(COOKIES_NAME.RACA)
  )
    return <ConfirmationBlockRaca user={user} fetchUser={handleNextBlock} />;

  if (showAlert)
    return (
      <div role="alert" className="eva-alert sucesso eva-mb-07">
        <div className="alerta-info">
          <i className="fa-regular fa-circle-check alerta-icon"></i>
          <p>Cadastrado com sucesso! Agradecemos pelas informações.</p>
        </div>
        <button
          aria-label="Fechar alerta"
          className="btn-close-alert"
          onClick={() => setShowAlert(false)}
        >
          <i className="fa-regular fa-xmark"></i>
        </button>
      </div>
    );

  return null;
};
